import { HttpHeaders, HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

export const 	authInterceptor: HttpInterceptorFn = (req, next) => {
	const token = sessionStorage.getItem('accessToken');

	if (!token) {
		return next(req);
	}

	const headers = new HttpHeaders({
		'Authorization': `Bearer ${token}`,
		// 'Accept-Language': 'pt',
	});

	const dupReq = req.clone({ headers });
	return next(dupReq);
};
